import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { accountsDividedToStatusesByOrgIdSelector } from "./accountsDividedToStatusesByOrgIdSelector";

export const activeAccountsLengthSelector = createDraftSafeSelector(
  [accountsDividedToStatusesByOrgIdSelector],
  (accounts) => {
    return accounts?.active?.length ?? 0;
  },
);
